import * as React from "react";
const ComplianceSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#EF4136"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m4.93 4.93 14.14 14.14M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
    />
  </svg>
);
export default ComplianceSVG;
